import React, { useState, useEffect, useRef } from "react";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";

const DateInput = ({
  label = "Label",
  handleChange = () => {},
  disablePast = true,
  value = null,
  lock = false,
  isDisabled = false,
}) => {
  const [isOpenDatePicker, setIsOpenDatePicker] = React.useState(false);
  const [currentValue, setCurrentValue] = useState(value);
  const toggleVisibility = () => setIsOpenDatePicker(!isOpenDatePicker);
  const changeDate = (e) => handleChange(e);
  const datePickerRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setIsOpenDatePicker(false);
      }
    };

    const handleScroll = () => {
      setIsOpenDatePicker(false);
    };

    // document.addEventListener("mousedown", handleClickOutside);
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      // document.removeEventListener("mousedown", handleClickOutside);
      window.removeEventListener("scroll", handleScroll, true);
    };
  }, []);

  useEffect(() => {
    if (!lock) {
      setCurrentValue(value);
    }
  }, [lock, currentValue, value]);

  return (
    <div
      className="col-span-6 sm:col-span-6 lg:col-span-3 flex flex-col w-full relative"
      ref={datePickerRef}
    >
      <p className="block text-[16px] font-medium">{label}</p>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <DatePicker
          open={isOpenDatePicker}
          onClose={() => setIsOpenDatePicker(false)}
          onOpen={() => setIsOpenDatePicker(true)}
          disablePast={disablePast}
          value={currentValue}
          onChange={(newValue) => changeDate(newValue)}
          format="DD/MM/YYYY"
          disabled={isDisabled}
          slotProps={{
            field: { toggleVisibility },
            textField: {
              size: "small",
              InputProps: {
                readOnly: true,
              },
              onClick: () => setIsOpenDatePicker(!isOpenDatePicker),
            },
          }}
        />
      </LocalizationProvider>
    </div>
  );
};

export default DateInput;
